jQuery('document').ready(function() {
  /* MENU MOBILE NAV */

  $(document).on('click', '.icon-toggle', function(e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).next().toggleClass('open');
    if($(this).next().hasClass('open')){
      $(this).next().show();
    }else{
      $(this).next().hide();
    }
  });
  $(document).on('click', '.js-mobile-nav-toggle', function(e) {
    $('body').toggleClass('open-nav');
  });
  $(document).on('click', '.mobile-nav--close', function(e) {
    $('.icon-toggle').removeClass('active');
    $('.menu-dropdown-wrapper').hide().removeClass('open');
  });

  /* FUNCTION ALIGN HEIGHT */
  function alignHeight(selector) {
    jQuery(selector).css('height', '');
    var minHeight = 0;
    jQuery(selector).each(function () {
        if (minHeight < jQuery(this).outerHeight()) {
            minHeight = jQuery(this).outerHeight();
        }
    });
    if (minHeight > 0) {
        jQuery(selector).css('height', minHeight);
    }
  }

  /* COMMON VARIABLES */
  var windowWidth = jQuery(window).width();

  /* SCROLL FADEIN ON ALL PAGE */
  AOS.init({
    once: true
  });

  /* Close button on success and error message */
  jQuery('.btn-close-message').click(function() {
    jQuery(this).parent().hide();
  });

  /* Make input animation */
  function updateTextFields() {
    var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], textarea';
    $(input_selector).each(function (index, element) {
      var $this = $(this);
      var inputId = $this.attr('id');
      if ($(element).val().length > 0 || $(element).is(':focus') || element.autofocus) {
        $('label[for="'+ inputId +'"]').addClass('active');
      } else if ($(element)[0].validity) {
        $('label[for="'+ inputId +'"]').toggleClass('active', $(element)[0].validity.badInput === true);
      } else {
        $('label[for="'+ inputId +'"]').removeClass('active');
      }
      if ($(element).is(':focus')) {
        $('label[for="'+ inputId +'"]').addClass('focusing');
      } else {
        $('label[for="'+ inputId +'"]').removeClass('focusing');
      }
    });
  };

  // Text based inputs
  var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], textarea';

  // Add active if form auto complete
  $(document).on('change', input_selector, function () {
    var inputId = $(this).attr('id');
    if ($(this).val().length !== 0 || $(this).attr('placeholder') !== undefined) {
      $('label[for="'+ inputId +'"]').addClass('active');
    }
  });
  var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
  if (isChrome || isSafari) {
    jQuery(document).ready(function() {
      setTimeout(function() {
        if($('input:-webkit-autofill')) {
          $('input:-webkit-autofill').each(function(){
            if ($(this).val().length !== "") {
              var inputId = $(this).attr('id');
              $('label[for="'+ inputId +'"]').addClass('active');
            }
          });
        }
      }, 200);
    });
  }

  // Add active if input element has been pre-populated on document ready
  $(document).ready(function () {
    updateTextFields();
  });

  // HTML DOM FORM RESET handling
  $(document).on('reset', function (e) {
    var formReset = $(e.target);
    if (formReset.is('form')) {
      formReset.find(input_selector).removeClass('valid').removeClass('invalid');
      formReset.find(input_selector).each(function () {
        var inputId = $(this).attr('id');
        if ($(this).attr('value') === '') {
          $('label[for="'+ inputId +'"]').removeClass('active');
        }
      });

      // Reset select
      formReset.find('select.initialized').each(function () {
        var reset_text = formReset.find('option[selected]').text();
        formReset.siblings('input.select-dropdown').val(reset_text);
      });
    }
  });

  // Add active when element has focus
  $(document).on('focus', input_selector, function () {
    var inputId = $(this).attr('id');
    $('label[for="'+ inputId +'"]').addClass('active');
    $('label[for="'+ inputId +'"]').addClass('focusing');
    $(this).siblings('.prefix').addClass('active');
  });

  $(document).on('blur', input_selector, function () {
    var $inputElement = $(this);
    var selector = ".prefix";
    var inputId = $(this).attr('id');
    if ($inputElement.val().length === 0 && $inputElement[0].validity.badInput !== true && $inputElement.attr('placeholder') === undefined) {
      $('label[for="'+ inputId +'"]').removeClass('active');
    }
    $('label[for="'+ inputId +'"]').removeClass('focusing');
    $inputElement.siblings(selector).removeClass('active');
  });

  /* Align height fyf page */
  	function alignHeight(selector) {
      jQuery(selector).css('height', '');
      var maxHeightName = 0;
      jQuery(selector).each(function() {
        if (maxHeightName < jQuery(this).height()) {
          maxHeightName = jQuery(this).height()
        }
      });
      if (maxHeightName > 0) {
        jQuery(selector).css('height', maxHeightName);
      }
    }
    setTimeout(function(){
      //alignHeight('.list-collection .grid.grid-product .item .title');
      //alignHeight('.cart-related-products .product-item .item-content .title');
      alignHeight('.article-other-posts .items .item h4');
      alignHeight('.article-other-posts .items .item .short-desc');
      alignHeight('.lh-cellar-door-middle .items .item .description');
    }, 500);

    jQuery(window).resize(function() {
      setTimeout(function(){
        //alignHeight('.list-collection .grid.grid-product .item .title');
        //alignHeight('.cart-related-products .product-item .item-content .title');
        alignHeight('.article-other-posts .items .item h4');
        alignHeight('.article-other-posts .items .item .short-desc');
        alignHeight('.lh-cellar-door-middle .items .item .description');
      }, 500);
    });

    if (windowWidth > 1024) {
      setTimeout(function(){
        alignHeight('.text-image-with-heading-text-wrap .list-items .title');
        alignHeight('.text-image-with-heading-text-wrap .list-items .text-content');
      }, 500);

      jQuery(window).resize(function() {
        setTimeout(function(){
          alignHeight('.text-image-with-heading-text-wrap .list-items .title');
          alignHeight('.text-image-with-heading-text-wrap .list-items .text-content');
        }, 500);
      });
    }

  /* CART SLIDEOUT TOGGLE */
  var currentScroll = 0;
	jQuery('.toggle-cart-slideout').click(function() {
		jQuery('.cart-slideout').toggleClass('open');
    jQuery('.cart-slideout-wrap').toggleClass('show-bg');
    if (jQuery(window).width() < 767) {
      currentScroll = jQuery(window).scrollTop();
      jQuery('body').css('top', 0 - currentScroll+'px');
    }
      jQuery('body').addClass('not-scroll');
	});
	jQuery('.close_cart_slideout').click(function() {
		jQuery('.cart-slideout').removeClass('open');
    jQuery('.cart-slideout-wrap').removeClass('show-bg');
    jQuery('body').removeClass('not-scroll');
    if (jQuery(window).width() < 767) {
      jQuery('body').css('top', '');
      $('html, body').animate({ scrollTop: currentScroll }, 0);
    }
  });
  $(document).on('click touchend', function (e) {
    var container = jQuery(".cart-slideout");
    var container2 = jQuery(".toggle-cart-slideout");
    if (!container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0) {
      if(container.hasClass('open')) {
        container.removeClass('open');
        jQuery('.cart-slideout-wrap').removeClass('show-bg');
        jQuery('body').removeClass('not-scroll');
        if (jQuery(window).width() < 767) {
          jQuery('body').css('top', '');
          $('html, body').animate({ scrollTop: currentScroll }, 0);
        }
      }
    }
  });

  /* Toggle footer menu on mobile */
  if (windowWidth < 768) {
    jQuery('.site-footer .middle-footer .footer-container>.grid:first-child .grid__item:not(:last-child) .footer-menu').hide();
    jQuery('.site-footer .middle-footer .footer-container>.grid:first-child .grid__item:not(:last-child) h4').click(function() {
      jQuery(this).next().slideToggle();
      jQuery(this).toggleClass('active');
    });
  }
  function changeQty() {
    const $qtyValue = $('.form-and-inner-circle-wrapper .product-form__input');
    let currenQty = 1;

    if ($qtyValue.length && $qtyValue.val()) {
      currenQty = parseInt($qtyValue.val(), 10);
    }
    if ($('.js-free-shipping-block').length) {
      var priceElement = $('.select-with-style .selected .price');
      var freeShippingAmount = parseFloat($('.js-free-shipping-block').attr('data-freeshipping-amount')) || 0;

      if (priceElement.length > 0) {
        var value = parseFloat(priceElement.text().replace(/[^0-9.]/g, '')) || 0;
        var displayPrice = Math.floor(value);

        var totalPrice = displayPrice * currenQty;

        if (totalPrice >= freeShippingAmount) {
          $('.js-free-shipping-block').addClass('active');
        } else {
          $('.js-free-shipping-block').removeClass('active');
        }
      } else {
        var originalPrice = $('.product-single__price #ProductPrice-product-template');
        if (originalPrice.length > 0) {
          var originalValue = parseFloat(originalPrice.text().replace(/[^0-9.]/g, '')) || 0;
          var displayOriginalPrice = Math.floor(originalValue);
          var sumPrice = displayOriginalPrice * currenQty;

          if (sumPrice >= freeShippingAmount) {
            $('.free-shipping-block').addClass('active');
          } else {
            $('.free-shipping-block').removeClass('active');
          }
        }
      }
    }
  }
  /* Quantity plus minus button */
  $('.button-plus').click(function(e){
    // Get its current value
    var currentVal = parseInt( $(this).prev().val());
    if ($(this).prev().hasClass('experiences-product')) {
        if (currentVal >= 4 && currentVal < 6) {
          $(this).prev().val(currentVal + 1);
          jQuery('.cart .cart__footer .btn.cart__update:not(.cart__continue--large)').trigger('click');
        }else{
          if (currentVal <= 4) {
            parseInt( $(this).prev().val(4));
          }
          if (currentVal >= 6) {
           parseInt( $(this).prev().val(6));
          }
        }
    } else {
      // If is not undefined
      if (!isNaN(currentVal)) {
        // Increment
        $(this).prev().val(currentVal + 1);
      } else {
        // Otherwise put a 1 there
        $(this).prev().val(1);
      }
      if ($(this).parent().hasClass('error-qty')) {
        $(this).parent().removeClass('error-qty');
        $(this).parent().siblings('.error-qty-message').remove();
      }
      jQuery('.cart .cart__footer .btn.cart__update:not(.cart__continue--large)').trigger('click');
    }
    changeQty();
  });
  // This button will decrement the value till 1
  $(".button-minus").click(function(e) {
    // Get its current value
    var currentVal = parseInt($(this).next().val());
    if ($(this).next().hasClass('experiences-product')) {
      if (currentVal > 4 && currentVal <= 6) {
        $(this).next().val(currentVal - 1);
        jQuery('.cart .cart__footer .btn.cart__update:not(.cart__continue--large)').trigger('click');
      } else{
        if (currentVal <= 4){
          $(this).next().val(4);
        }
      }
    }
    else{
      // If it isn't undefined or its greater than 0
      if (!isNaN(currentVal) && currentVal > 1) {
        // Decrement one
        $(this).next().val(currentVal - 1);
      } else {
        // Otherwise put a 1 there
        $(this).next().val(1);
      }
      if ($(this).parent().hasClass('error-qty')) {
        $(this).parent().removeClass('error-qty');
        $(this).parent().siblings('.error-qty-message').remove();
      }
      jQuery('.cart .cart__footer .btn.cart__update:not(.cart__continue--large)').trigger('click');
    }
    changeQty();
  });
  $('.form-and-inner-circle-wrapper .product-form__input').on('change', function () {
    changeQty();
  });

    /* NEWSLETTER POPUP */
  $('.popup-close-btn').click(function() {
    $('.popup-newsletter-wrapper').hide();
  });

  $(window).load(function() {
    /* fix conflict Cookie */
    var Cookies2 = Cookies.noConflict(); // fix if conflict

    /* POPUP NEWSLETTER */
    if ($('.popup-newsletter-wrapper').length > 0) {
      var expiresPopup = $('.popup-newsletter-wrapper').data('expire');
      if (Cookies2.get('popup-newsletter') === undefined) {
        //no cookie
        $('.popup-newsletter-wrapper').addClass('active');
        Cookies2.set("popup-newsletter", 1, { expires : expiresPopup });
      } else {
        //have cookie
        Cookies2.set("popup-newsletter", 1, { expires : expiresPopup });
      }
    }
  });

  /* CHALLENGE PAGE SCROLL TO TOP */
  $(window).load(function(){
    if ($('.shopify-challenge__container .shopify-challenge__message').length) {
      $("html, body").animate({ scrollTop: 0 }, "fast");
    }
    changeQty();
  });

  if(windowWidth < 768){
    if(jQuery('.inner-circle-benefits').length > 0)
      jQuery('.inner-circle-benefits').insertBefore('.inner-circle-top .text .content');
  }

  /* STYLE DROPDOWN */
  $('.select-with-style .current-select-value').click(function() {
    $('.select-with-style .current-select-value').not(this).each(function(){
      if($(this).hasClass('open')){
        $(this).toggleClass('open');
        $(this).prev().toggleClass('open');
        $(this).next().toggleClass('open');
      }
    });
    $(this).toggleClass('open');
    $(this).prev().toggleClass('open');
    $(this).next().toggleClass('open');
  });
  $('.select-with-style .select-options li').click(function() {
    if ($(this).attr('data-variant-value')) {
        var optionValue = $(this).data('variant-value');
    } else {
        var optionValue = $(this).data('value');
    }
    var optionText = $(this).text();
    $(this).siblings().removeClass('selected');
    $(this).addClass('selected');
    $(this).parent().parent().prev().val(optionValue).change();
    $(this).parent().prev().text(optionText).attr('data-value', optionValue).toggleClass('open');
    $(this).parent().prev().prev().toggleClass('open');
    changeQty();
  });

  $(document).mouseup(function(e) {
    var container = $('.select-with-style');
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $('.select-with-style .select-with-style-label.open').removeClass('open');
      $('.select-with-style .current-select-value.open').removeClass('open');
      $('.select-with-style .select-options.open').removeClass('open');
    }
  });

  /* active link on menu */
  if ($('.lh-cms-page-heading').length) {
    var parent = $('.lh-cms-page-heading .top-heading-wrapper .heading-text p').text().toLowerCase();;
    $('.site-nav--centered .site-nav__link--main').each(function() {
      if ($(this).text().toLowerCase() == parent) {
        $(this).addClass('current');
      }
    });
  }
  if ($('.lh-collection-heading').length) {
    var parent = $('.lh-collection-heading .top-heading-wrapper p').text().toLowerCase();;
    $('.site-nav--centered .site-nav__link--main').each(function() {
      if ($(this).text().toLowerCase() == parent) {
        $(this).addClass('current');
      }
    });
  }

  /* Sicky header only when scroll down not scroll up */
  var lastScrollTop = 0;
  var navbarHeight = $('#shopify-section-header').outerHeight();
  // on scroll, let the interval function know the user has scrolled
  $(window).scroll(function(event){
    if (!$('.site-header .mobile-nav--close').length && !$('.cart-slideout-wrap').hasClass('show-bg')) {
      var st = $(this).scrollTop();

      // If they scrolled down and are past the navbar, add class .nav-up.
      // This is necessary so you never see what is "behind" the navbar.
      if (st > lastScrollTop && st > navbarHeight){
          // Scroll Down
          $('#shopify-section-header').removeClass('nav-down').addClass('nav-up');
      } else {
          // Scroll Up
          if (st > navbarHeight) {
            if(st + $(window).height() < $(document).height()) {
              $('#shopify-section-header').removeClass('nav-up').addClass('nav-down');
            }
          }
          if (st == 0) {
            $('#shopify-section-header').removeClass('nav-up').removeClass('nav-down');
          }
      }

      lastScrollTop = st;
    }
  });

  /* FIRST TOUCH AS HOVER ON MAIN MENU TABLET */
  if (windowWidth < 1025 && windowWidth > 767) {
    $('.site-nav--centered .site-nav__link--main:not(:last-child)').click(function(e) {
      if (!$(this).hasClass('tablet-hover')) {
        $('.site-nav--centered .site-nav__link--main').removeClass('tablet-hover');
        $(this).addClass('tablet-hover');
        e.preventDefault();
      }
    });
    $(document).on('click touchend', function (e) {
      var container = $("#AccessibleNav");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.site-nav--centered .site-nav__link--main').removeClass('tablet-hover');
      }
    });
  }

});

// pick dates .
$(document).ready(function($) {
  $( ".datepicker" ).datepicker({
    dateFormat: 'dd/mm/yy',
    minDate: 0,
    onSelect: function(e) {
      if ($(this).val() != null && $(this).val() != '') {
        $(this).removeClass('error');
        $('label[for="'+ $(this).attr('id') +'"].error').remove();
        $('label[for="'+ $(this).attr('id') +'"]').addClass('active').removeClass('error-label');
      }
    }
  });
  // creat date pick
  $('#btn-slide-enquiry,#close_slide').click(function(event) {
    event.preventDefault();
    /* Act on the event */
    $('.slide-enquiry-wrapper').toggleClass('openslide_enquiry');
    $('body').toggleClass('opening-slideout-enquiry');
  });
  $(document).on('click touchend', function (e) {
    var container = $(".slide-enquiry-wrapper .slide-enquiry");
    var container2 = $("#btn-slide-enquiry");
    var datepick = $("#ui-datepicker-div");
    if (!container.is(e.target) && container.has(e.target).length === 0 && !datepick.is(e.target) && datepick.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0) {
        //container.parent().removeClass('openslide_enquiry');
        //$('body').removeClass('opening-slideout-enquiry');
    }
  });
});

$(document).ready(function() {
  /* Button change email */
  $('.btn-change-email').click(function() {
    $('.btn-change-email').hide();
    $('.message_formchange').hide();
    $('.customer-info #customer_metafields .input_email').removeClass('error');
    $('#customer_metafields').show("slow", function() {});
    $('.btn-close-message').parent().hide();
  });
});
  function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  // function validate() {
  //   var $result = $("#result");
  //   var email = $("#email").val();
  //   $result.text("");

  //   if (validateEmail(email)) {
  //     $result.text(email + " is valid :)");
  //     $result.css("color", "green");
  //     return true;
  //   } else {
  //     $result.text(email + " is not valid :(");
  //     $result.css("color", "red");
  //     return false;
  //   }

  // }
$(document).ready(function() {
  $('#first_name, #last_name, #_email').focus(function(event) {
    $(this).removeClass('error');
    $(this).css("border-color","#a68f58");
    $(this).next(".mess_error").remove();
  });
  $('.js-cm-submit-button').click(function() {
    $('.mess_error').remove();
    var check = 0;
    $('#first_name, #last_name, #_email, #_birth_day, #_birth_month, #_birth_year').each(function() {
      if ($(this).val() == '') {
        var name = $(this).attr("name")
        $(this).parent().append("<p class='mess_error' style='color: #ff0000;'>"+name+" can't be blank</p>");
        $(this).css("border-color","#ff0000");
        $(this).addClass('error');
      }else if ($(this).attr("id") == "_email" && !validateEmail($(this).val())) {
        var namemail = $(this).attr("name")
        $(this).parent().append("<p class='mess_error' style='color: #ff0000;'>"+namemail +" can't be valid</p>");
      } else {
        check += 1;
      }
    });
    if (check == 6) {
      $('#modal_form_popup .customr-container .customr-container-item[data-customr-container-item-name="customer[first_name]"] label').addClass('active focusing');
      $('.customr-container-item[data-customr-container-item-name="customer[first_name]"] input').val($('#first_name').val());
      $('#modal_form_popup .customr-container .customr-container-item[data-customr-container-item-name="customer[last_name]"] label').addClass('active focusing');
      $('.customr-container-item[data-customr-container-item-name="customer[last_name]"] input').val($('#last_name').val());
      $('#modal_form_popup .customr-container .customr-container-item[data-customr-container-item-name="customer[email]"] label').addClass('active focusing');
      $('.customr-container-item[data-customr-container-item-name="customer[email]"] input').val($('#_email').val());
      $('#modal_form_popup .customr-container .customr-container-item[data-customr-container-item-name="customer[birthday_day]"] label').addClass('active focusing');
      $('.customr-container-item[data-customr-container-item-name="customer[birthday_day]"] select').val($('#_birth_day').val());
      $('#modal_form_popup .customr-container .customr-container-item[data-customr-container-item-name="customer[birthday_month]"] label').addClass('active focusing');
      $('.customr-container-item[data-customr-container-item-name="customer[birthday_month]"] select').val($('#_birth_month').val());
      $('#modal_form_popup .customr-container .customr-container-item[data-customr-container-item-name="customer[birthday_year]"] label').addClass('active focusing');
      $('.customr-container-item[data-customr-container-item-name="customer[birthday_year]"] select').val($('#_birth_year').val());
      $('#modal_form_popup').show();
      $('body').addClass('opacity_custom');
    }
  });
  $('#close_modal_form_popup').click(function() {
    $('#modal_form_popup').hide();
    $('body').removeClass('opacity_custom');
  });
  $('.lh-experience-landing-content .image').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true
  });
  $('#shopify-section-lh-cms-page-heading-v2 .lh-cms-page-heading').slick({
    adaptiveHeight: true
  });
  $('.search-top-icon').on('click', function(){
    $('#SearchDrawer').toggleClass('show');
  });
  $('.search-bar__close').on('click', function(){
    $('#SearchDrawer').removeClass('show');
  });
  $('.reviews-awards .review-items').slick({
      dots: true,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      appendArrows: '.custom-controls',
      appendDots: '.custom-controls',
      prevArrow: '<button type="button" class="slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-next"></button>',
      dotsClass: 'slick-dots'
  });
  /* ADD TO CART */
  function addToCart(form) {
      $('.ajax-loader').show();
      $.ajax({
          type: 'POST',
          url: '/cart.js',
          dataType: 'json',
          xhrFields: {
              withCredentials: true
          },
          success: function(cart) {
              var canAddToCart = true;
              form.find('.error-product-type').remove();
              var vId = form.find('input[name="id"]').val();
              if (canAddToCart) {

                  var formInfo = 'quantity=1' + '&id=' + parseInt(vId);

                  form.find('.form-message-ajax').remove();
                  $.ajax({
                      type: 'POST',
                      url: '/cart/add.js',
                      data: formInfo,
                      dataType: 'json',
                      success: function(line_item) {
                          var btnMiniCart = $('.site-header .site-header__cart');
                          $.ajax({
                              url: line_item.url,
                              type: "GET",
                              data: {"view": "ajax"},
                              xhrFields: {
                                  withCredentials: true
                              },
                              dataType: 'html',
                              success: function(response) {
                                  $('.ajax-loader').hide();
                                  var headerCartHtml = $(response).find('.site-header__cart').first().html();
                                  var slideoutCartHtml = $(response).find('.cart-slideout').first().html();

                                  if (headerCartHtml) {
                                      $('.site-header .site-header__cart').html(headerCartHtml);
                                  }
                                  if (slideoutCartHtml) {
                                      $('.cart-slideout').html(slideoutCartHtml);
                                  }

                                  // click btn remove item using ajax
                                  $('.cart-slideout > .content .item .quantity .cart__remove').click(function(e) {
                                      e.preventDefault();
                                      var removeCartUrl = $(this).attr('href');
                                      removeCartAjax(removeCartUrl);
                                  });

                                if(!$('.cart-slideout').hasClass('open'))
                                  btnMiniCart.trigger('click');
                              },
                              error: function(XMLHttpRequest, textStatus) {
                                  $.ajax({
                                      url: '/',
                                      type: "GET",
                                      data: {"view": "ajax"},
                                      xhrFields: {
                                          withCredentials: true
                                      },
                                      dataType: 'html',
                                      success: function(response) {
                                          $('.ajax-loader').hide();
                                          var headerCartHtml = $(response).find('.site-header__cart').first().html();
                                          var slideoutCartHtml = $(response).find('.cart-slideout').first().html();

                                          if (headerCartHtml) {
                                              $('.site-header .site-header__cart').html(headerCartHtml);
                                          }
                                          if (slideoutCartHtml) {
                                              $('.cart-slideout').html(slideoutCartHtml);

                                          }
                                          // click btn remove item using ajax
                                          $('.cart-slideout > .content .item .quantity .cart__remove').click(function(e) {
                                              e.preventDefault();
                                              var removeCartUrl = $(this).attr('href');
                                              removeCartAjax(removeCartUrl);
                                          });

                                          btnMiniCart.trigger('click');
                                      }
                                  });
                              }
                          });
                      },
                      error: function(XMLHttpRequest, textStatus) {
                          $('.ajax-loader').hide();
                          var data = eval('(' + XMLHttpRequest.responseText + ')');
                          var errorMessage = '';
                          if (!!data.message) {
                              errorMessage = data.description
                          } else {
                              errorMessage = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
                          }
                          if (errorMessage !== '') {
                              form.closest('.product-grid-content-bottom').addClass('form--error');
                              form.append('<div class="form-message form-message-ajax form-message--error"><div class="errors"><ul><li>'+ errorMessage +'</li></ul></div><span class="btn-close-message"></span></div>');
                              form.find('.form-message-ajax .btn-close-message').first().click(function() {
                                  $(this).parent().remove();
                              });
                          }
                      }
                  });
              } else {
                  $('.ajax-loader').hide();
              }
          }
      });
  }

  // event item add to cart
  $(document).on('submit', '.product-cart-gird-form', function(e) {
      e.preventDefault();
      addToCart($(this));
  });
  // Function to check when ReCharge widget is ready
  const waitReChargeReady = setInterval(() => {
    if ($('.rc-widget-injection-parent:has(".rc-selling-plans")').length > 0) {
      // Add the heading to Recharge layout when it's not rendered by app
      if (!$('.rc-option.rc_widget__option').has(".rc_widget__option__selector").length) {
        let rcOptionLabel = 'RECURRING ORDER';
        if ($('.rc-option.rc_widget__option').hasClass('rc-option__onetime')) {
          rcOptionLabel = 'ONE-TIME PURCHASE';
        }
        $('.rc-option.rc_widget__option').addClass('rc-option--active').prepend(`<div class="rc_widget__option__selector" data-selector-subsave=""><label class="rc-radio__label rc_widget__option__label" for=""><span class="rc-option__text">${rcOptionLabel}</span></label></div>`);
      }
      $('.rc_widget__option__plans').append($('.rc_note'));
      $('.rc_popup_label_wrapper').append($('.rc-learn_more-icon'));
      clearInterval(waitReChargeReady);
    }
  }, 100);
});
